



































import { Vue, Component } from "vue-property-decorator";
import { getParam } from "@/api/teacherInfoManage";
import { getBizStatByDistrict, getBizStatBySchool } from "@/api/teacherBizStat";

@Component({ name: "teacherBizStat" })
export default class extends Vue {
  private projectId = "";
  private projects: any[] = [];
  private byDistrict: any[] = [];
  private bySchool: any[] = [];
  private loading = false;

  created() {
    this.loadProjects();
  }

  private async loadProjects() {
    const res = await getParam();
    this.projects = res.data.projects || [];
  }

  private async loadAll() {
    if (!this.projectId) {
      this.$message.warning("请选择项目");
      return;
    }
    this.loading = true;
    try {
      const [d, s] = await Promise.all([
        getBizStatByDistrict(this.projectId),
        getBizStatBySchool(this.projectId)
      ]);
      this.byDistrict = d.data || [];
      this.bySchool = s.data || [];
    } catch (e) {
      const err = e as any;
      this.$message.error(err.mesg || err.message || "加载失败");
    } finally {
      this.loading = false;
    }
  }
}
